import { Buttons } from "@/ui/Buttons";
import { TeamMemberDetailCard } from "@/ui/TeamMemberDetailCard";
import cn from "classnames";
import { Container } from "react-bootstrap";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useTeam from "hooks/useTeam";

export const TeamDetailCarousel = ({
  className = "py-4 py-md-5",
  title,
  content,
  theme = "light",
  sectionId,
  swiperID = "team-swiper",
  team, // Array of team member IDs
}) => {
  const allTeams = useTeam();

  // Filter allTeams to only include the members present in team array
  const filteredTeam = allTeams.filter((member) => team.includes(member.id));

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .${swiperID}`,
    },
    navigation: {
      nextEl: `.${swiperID}.swiper-next`,
      prevEl: `.${swiperID}.swiper-prev`,
    },
  };

  return (
    <div id={sectionId} className={cn(className)} data-bs-theme={theme}>
      <Container fluid="lg">
        <div className="flex-md-row justify-content-between align-items-center">
          <div>
            <h3 className="mb-1">{title}</h3>
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
          <a
            href={`/team`}
            className="primaryBtn no-arrow text-nowrap mb-2 mb-md-0"
          >
            Meet the team
          </a>
        </div>
        <Swiper {...settings}>
          {filteredTeam.map((member) => (
            <SwiperSlide key={member.id}>
              <TeamMemberDetailCard {...member} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </div>
  );
};

export default TeamDetailCarousel;
